import qwest from 'qwest';

import Medusa from 'medusajs';

import Dealer from '../models/dealer.jsx';

let DealerApi = {

  getDealer(id) {
    return Medusa.get('Dealer:' + id, (resolve, reject) => {
      qwest.get(`/Dealer/Index/${id}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(Dealer.fromApiFormat(response.data));
          } else {
            reject(response);
          }
        });
    }, 8 * 360 * 1000); // Cache for .8 hours
  },

  saveDealer(dealer, b64data) {
    let apiDealer = dealer.toApiFormat();

    if (b64data) {
      return qwest.post(`/Dealer/WithLogo/${dealer.id}`, {
        dealer: apiDealer,
        logo: b64data,
      })
      .then((xhr, response) => {
        if (response.success) {
          let dealer = Dealer.fromApiFormat(response.data);

          Medusa.put('Dealer:' + dealer.id, dealer, 8 * 360 * 1000); // Cache for .8 hours
          return dealer;
        }
        throw response;
      });
    }

    return qwest.post(`/Dealer/Index/${dealer.id}`, apiDealer)
      .then((xhr, response) => {
        if (response.success) {
          let dealer = Dealer.fromApiFormat(response.data);

          Medusa.put('Dealer:' + dealer.id, dealer, 8 * 360 * 1000); // Cache for .8 hours
          return dealer;
        }
        throw response;
      });
  },

  getAPIKey(dealerID, dateCreated, type) {
    let payload = {
      dealerID,
      dateCreated,
      type,
    };

    return qwest.post(`/Login/GenerateAPIKey`, payload).then((xhr, response) => {
      return response.data.token;
    });
  },

  saveDealerUserAccess(dealerID, usersAccess) {
    return qwest.post(`/Dealer/SetUserAccess/${dealerID}`, usersAccess)
      .then((xhr, response) => {
        if (response.success) {
          let dealer = Dealer.fromApiFormat(response.data);

          Medusa.put('Dealer:' + dealer.id, dealer, 8 * 360 * 1000); // Cache for 8 hours
          return dealer;
        }
        throw response;
      });
  },
};

export default DealerApi;
